import React from "react";
import { useLocation } from "react-router-dom";
import { useAuthentication } from "@planzone/view-models";

import { AccountCreationConfirmation } from "@scenes/accountCreationConfirmation";
import { Props } from "./types";
import styles from "./styles.scss";
import logo from "../landingPage/logo.png";

function useQuery() {
  const query = new URLSearchParams(useLocation().search);

  return { get: (name: string) => query.get(name) || "" };
}

function AccountCreationConfirmationPage(props: Props) {
  const { get } = useQuery();
  const { authenticate } = useAuthentication();

  React.useEffect(() => {
    const code = get("code");

    authenticate({ code });
  }, []);

  return (
    <div className={styles.accountCreationConfirmationPage}>
      <div className={styles.header}>
        <div className={styles.logoBox}>
          <img className={styles.logo} src={logo} alt="Augeo Logo" />
        </div>
      </div>
      <div className={styles.main}>
        <div className={styles.accountCreationConfirmation}>
          <AccountCreationConfirmation
            userId={get("userId")}
            username={get("username")}
            title={get("title")}
            planzone={{
              name: get("planzoneName"),
              domain: get("planzoneDomain"),
            }}
            address={get("address")}
            companyName={get("companyName")}
            password={get("password")}
            passwordConfirmation={get("password")}
            hasRequestedPlanzoneCreation={!!get("hasRequestedPlanzoneCreation")}
          />
        </div>
      </div>
    </div>
  );
}

export { AccountCreationConfirmationPage };
